import authStore from './auth';
import commonStore from './common';
import cartState from './cart';

export const MODULES = {
    authStore,
    commonStore,
    cartState
};